import { render, staticRenderFns } from "./ContentSlider.vue?vue&type=template&id=5133e2d6&"
import script from "./ContentSlider.vue?vue&type=script&lang=js&"
export * from "./ContentSlider.vue?vue&type=script&lang=js&"
import style0 from "./ContentSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports